import React, { Component }
from 'react';
import { BrowserRouter as Router, Route, Link, Redirect, NavLink, HashRouter }
from "react-router-dom";
import Header from './../../Header';
import $ from 'jquery';
import Add_ticket from './../../assets/images/add.png';
//import DatePicker from 'react-datepicker';
import moment from 'moment';
import CryptoJS from 'crypto-js';
import config from 'react-global-configuration';
import OrgchartByPeople from './OrgchartByPeople';
import GroupDetailWithTroops from './GroupDetailWithTroops';
import GroupDetailWithMembers from './GroupDetailWithMembers';
class Orgchart extends Component {
constructor() {
        super();
        var has_local_data = localStorage.getItem('encdata') ? 1 : 0;
        var localdata = has_local_data ? this.decrypt(localStorage.getItem('encdata'), 0) : '';
        this.state = {
        apiUrl: this.decryptconfigdata('apiUrl'),
        userAuthKey: has_local_data ? localdata.user_key : '',
        userId: has_local_data ? localdata.user_id : '',
        userEmail: has_local_data ? localdata.user_email : '',
        orgchart_by:false,
        groups:[],
        group_types:[],
        group_members:[],
        activeGroupId:"",
        showMore:0,
        total_group_count:"",
        loading: 1,
        subloading: 1,
        page_no:1,
        srch_val:{},
        scroll_height:false,
        selectedGroup:""
        };
        this.searchKeyWords = this.searchKeyWords.bind(this);
        this.podList = this.podList.bind(this);
}

decryptconfigdata(configkey) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var bytes = CryptoJS.AES.decrypt(config.get(configkey), key, {
    iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return plaintext;
}

decrypt(findresponse, flg) {
    var key = CryptoJS.enc.Hex.parse(config.get('enc_key'));
    var iv = CryptoJS.enc.Hex.parse(config.get('enc_iv'));
    var res = flg ? findresponse.encdata : findresponse;
    var bytes = CryptoJS.AES.decrypt(res, key, {
    iv
    });
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    return JSON.parse(plaintext);
}

back() {
    window.location.href = '/employees/';
}

componentDidMount() {
    var obj = this;
    document.title = "Intranet | Organizationchart";
    if (!localStorage.getItem('userLogin')) {
        this.setState({ redirect: true });
    }
    var current_url = window.location.href.split('/')[3];
    var selected_grp_id = current_url.split('_')[1];
    if(selected_grp_id){
        this.setState({activeGroupId:selected_grp_id});
    }
    this.podList();
    
    document.addEventListener('scroll',function(){
        var scroll_height = window.scrollY;
        if(scroll_height > 350){
            obj.setState({scroll_height:true});
        }else{
            obj.setState({scroll_height:false});
        }
    })
    return function(){
        window.removeEventListener('scroll');
    }
}

podList(showmore,srchval){
    var postData = {};
    if(showmore){
        postData['showmore'] = showmore;
        var page_no = this.state.page_no;
        page_no = page_no + 1;
        this.setState({page_no,subloading:1});
        postData['page_no'] = page_no;
    }else{
        this.setState({ loading: 1 });
        var page_no = 1;
        this.setState({page_no});
        postData['page_no'] = page_no;
    }
    postData['srchval'] = this.state.srch_val;
    fetch(this.state.apiUrl + '/HrmanagementRest/GetAllGroupsWithMembers/userAuthKey/' + this.state.userAuthKey, {
        method: 'POST',
        dataType: 'json',
        body: JSON.stringify(postData),
    })
    .then((Response) => Response.json())
    .then((findresponse) => {
    findresponse = this.decrypt(findresponse, 1);
        var group_types = findresponse.group_types;
        var recent_data = findresponse.groups;
        if(showmore){
            var resultant_arr = [...this.state.groups,...recent_data];
        }else{
            var resultant_arr = recent_data;
        }
        this.setState({loading: 0,subloading:0,groups: resultant_arr,group_types,total_group_count:findresponse.total_group_count})
    })
}
showOrgChart(e){
    var checkbox_id = e.target.id;
    var orgchart_by = this.state.orgchart_by;
    this.setState({orgchart_by:e.target.checked});
}
showGroupDetail(e,group_id){
    this.setState({activeGroupId:group_id});
    $(".tab-pane").hide();
    $("#sub_"+group_id).show();
//    $("#showGroupDetail").show();
    $("#scrollTop").show();
}
searchKeyWords(e){
    var srch_value = this.state.srch_val;
    var obj = this;
    srch_value['srch_keyword'] = e.target.value;
    this.setState({srch_val:srch_value});
    if (this.timer) {
        window.clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(function () {
        //Execute the function code here...
        obj.podList(); 
    }, 500);
}
filterGroup(e){
    var srch_value = this.state.srch_val;
    srch_value['filter_group'] = e.target.value;
    this.setState({srch_val:srch_value});
    this.podList();
}
moveTop(e){
    $(window).scrollTop(0);
}

render() {
if (this.state.redirect) {
return (
        <Redirect to={'/login'} />
        )
}

var groups = this.state.groups;
return (
        <div>
                <Header brecum_name="Organization chart" brecum_page="Organization chart" />
                <div class="right_col" style={{overflow:"hidden"}}>
                    <div class="intranet_body dashboard">
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-9 col-lg-9">
                            {this.state.orgchart_by === true ?
                                <div class="pre-orgfilter">
                                <div class="people-search">
                                    <input type="text" placeholder="Search group by name or email" autocomplete="off" class="input-search" onChange={(e) => this.searchKeyWords(e)} />
                                    <button type="submit" class="search-btn">
                                        <span>
                                            <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path d="M12.0732 11.25L15.0732 14.25" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                                <path d="M8.32324 12.25C10.9466 12.25 13.0732 10.1234 13.0732 7.5C13.0732 4.87665 10.9466 2.75 8.32324 2.75C5.69989 2.75 3.57324 4.87665 3.57324 7.5C3.57324 10.1234 5.69989 12.25 8.32324 12.25Z" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>                                    
                                        </span>
                                    </button>
                                </div>
                                    <div class="select-search">
                                        <label class="filter-title">Filter By :</label>
                                        <span class="multiselect-native-select">
                                            <select class="form-control dropdown-toggle" id="group_type" name="group_type" onChange={(e) => this.filterGroup(e)}>
                                                <option value="">All</option>
                                                {this.state.group_types && this.state.group_types.length > 0 ?
                                                this.state.group_types.map((group_type_data) =>
                                                <option value={group_type_data.group_type} selected={group_type_data.group_type == "" ? "selected":""}>{group_type_data.type_name}</option>
                                                )
                                                :""}
                                </select>
                                        </span>
                                    </div>
                                </div>
                            :""}
                            </div>
                            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                                <div class="people-pod-switchtopic">
                                    <span class="peopo-by">By :</span>
                                    <div class="btn-container">
                                        <label class="switch btn-color-mode-switch">
                                            <input type="checkbox" name="color_mode" id="color_mode" value={this.state.orgchart_by} checked = {this.state.orgchart_by} onChange={(e) => this.showOrgChart(e)} />
                                            <label for="color_mode" data-on="Group" data-off="People" class="btn-color-mode-switch-inner"></label>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
        
                        {this.state.orgchart_by === true ?
                        <div class="row">
                            <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                <div class="allpod-box">
                                    <ul class="nav nav-tabs" role="tablist">
                                    {this.state.loading ?
                                    <div class="loader-new"></div>
                                    :
                                    (groups) ?
                                        Object.values(groups).map((data, sequence) =>
                                        <li role="presentation" atr={sequence}  id={`main_${data.group_data.id}`} class = {this.state.activeGroupId == data.group_data.id ? "active orgchart_box tooltips":"orgchart_box tooltips"}>
                                            <div class="tooltiptext"><div class="tip_name">{data.group_data.name}</div></div>
                                            <a href={`#sub_${data.group_data.id}`} onClick={(e) =>this.showGroupDetail(e,data.group_data.id)} >
                                                <div class="product">{data.group_data.name.length > 10 ? data.group_data.name.substring(0,10)+"...":data.group_data.name}</div>
                                                <div class="member">{data.group_data.members}{parseInt(data.group_data.group_type) === 3 ? " Pods": " Members"} ({data.group_data.short_name})</div>
                                            </a>
                                        </li>  
                                        )         
                                    :""}
                                        {groups.length> 0 && (groups.length != this.state.total_group_count) ?
                                        !this.state.subloading ?
                                        <div className="tab-content-showmore" id="show-more"  onClick={() =>this.podList(1)}>
                                            <div>SHOW MORE
                                                <span>
                                                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15 6.7628L9 12.7742L3 6.7628L4.0605 5.70029L9 10.6491L13.9395 5.70029" fill="#5A738E"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                            
                                        </div>
                                        :
                                        <div className="tab-content-showmore" id="show-more"  >
                                            {this.state.subloading ?
                                            <div><i className="fa fa-spinner fa-spin"></i><span> Wait</span></div>
                                            :
                                            <div>SHOW MORE
                                                <span>
                                                    <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M15 6.7628L9 12.7742L3 6.7628L4.0605 5.70029L9 10.6491L13.9395 5.70029" fill="#5A738E"></path>
                                                    </svg>
                                                </span>
                                            </div>
                                            }
                                        </div>
                                        :""}
                                    </ul>
                                    
                                    <div class="tab-content custom-tab-content">
                                        {(groups && Object.values(groups).length > 0) ?
                                        Object.values(groups).map((data, sequence) =>
                                            parseInt(data.group_data.group_type) == 3 ?
                                                    <GroupDetailWithTroops activeGroupId={this.state.activeGroupId} group ={data.hasOwnProperty('group') ? data.group:""} group_detail={data.group_data}/>
                                                            :
                                                    <GroupDetailWithMembers activeGroupId={this.state.activeGroupId} parent={this} scrollHeight={this.state.scroll_height} group_members={data.group && data.group} group_detail={data.group_data} groupType = {data.group_data.group_type}/>
                                        )
                                :""}
                                    </div>   
                                </div>
                            </div>
                        </div>
                        :
                                <div >
                                    <OrgchartByPeople  />
                                </div>
                        }
                </div>
            </div>
        </div>
        );
        }

}
export default Orgchart;


// WEBPACK FOOTER //
// ./src/components/hrAdmin/orgchart.js